<!-- @veltra/icons generated sha256:b86cb51d670d8453 gen:8 source:src/svg/normal/video-pause.svg -->
<script setup lang="ts">
defineOptions({ name: 'VideoPause' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m0 1a6 6 0 1 1 0 12A6 6 0 0 1 8 2M6 5.493C6 5.217 6.228 5 6.496 5c.276 0 .504.217.504.493v5.014a.496.496 0 0 1-.496.493.5.5 0 0 1-.504-.493zm3 0C9 5.217 9.228 5 9.496 5c.276 0 .504.217.504.493v5.014a.496.496 0 0 1-.496.493.5.5 0 0 1-.504-.493z"
    />
  </svg>
</template>
